export default __webpack_public_path__ + "static/media/netherlands-flag-icon.66ea2e65.svg";